export class PostCatToolAnalysis {
    csvFile?: File;
    catToolId?: number;
    clientId?: number;
    resourceId?: number;
}

export class PostCatToolSetting {
    catToolName?: string;
    insertDate?: string;
    insertUserId?: number;
    delimiter?: string;
    wordsColumn?: number;
    rowsToSkip?: number;
    columnName?: string;
    direction?:string;
}

export class ResponseCatToolSetting extends PostCatToolSetting {
    catToolId?: number;
    id?: number;
    wordsCount?: number;
}

export class ResponseCatToolAnalysis extends ResponseCatToolSetting {
    discountPercentage?: number;
    discountedWordCount?: number;
}

export class ResponseCatToolAnalysisResult {
    analysis?: ResponseCatToolAnalysis[];
    totalWordCount?: number;
    totalDiscountedWordCount?: number;
}

export class AiCatCategory {
    targetField?: string;
    sourceName?: string;
    words?: number;
    confidence?: number;
}

export class ResponseAiCatToolAnalysisExtract {
    detectedTool?: string;
    totalWords?: number;
    notes?: string;
    categories?: AiCatCategory[];
}

export class PostAiCatToolAnalysisSubmit {
    catToolId?: number;
    clientId?: number;
    resourceId?: number;
    categories?: AiCatCategory[];
}